export function RichText({ text, className = "" }) {
  if (!text) return null;
  const blocks = text.split(/\n\s*\n/);
  return (
    <div className={`prose-site ${className}`}>
      {blocks.map((b) => {
        const lines = b.split("\n").filter((l) => l.trim());
        if (lines.length && lines.every((l) => l.trim().startsWith("- "))) {
          return (
            <ul key={b}>
              {lines.map((l) => (
                <li key={l}>{l.trim().slice(2)}</li>
              ))}
            </ul>
          );
        }
        return <p key={b}>{lines.join(" ")}</p>;
      })}
    </div>
  );
}

export function Sections({ sections = [], testid = "page-sections" }) {
  return (
    <div className="space-y-12" data-testid={testid}>
      {sections.map((s) => (
        <section key={`${s.heading}|${(s.body || "").slice(0, 40)}`}>
          {s.heading && <h2 className="mb-4 text-xl font-bold text-zinc-950 sm:text-2xl">{s.heading}</h2>}
          <RichText text={s.body} />
        </section>
      ))}
    </div>
  );
}
